'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.toNextSection = void 0;
var $ = require("jquery");
var toNextSection = /** @class */ (function () {
    function toNextSection() {
        this.tops = {};
        this.count = 0;
        var self = this;
        // 表示中のページの各セクションの高さを取得
        this.getSections();
        // 10秒スクロールがなく次のセクションがまだあれば、ボタンを表示させる
        setInterval(function () {
            self.count++;
            // console.log(self.count);
            if (self.count == 10) {
                $('#bulletToNextSection').addClass('visible');
            }
        }, 1000);
        // スクロールを検知
        $(window).on('scroll', function () {
            self.count = 0;
        });
        // ボタンクリック
        $('#trigToNextSection').on('click', function () {
            // 次のセクション位置を取得
            var nextSectionId = self.getNextSectionId();
            // 移動
            self.scrollTo(nextSectionId);
            // ボタンを隠す
            $('#bulletToNextSection').removeClass('visible');
            self.count = 0;
        });
    }
    toNextSection.prototype.getSections = function () {
        var self = this;
        var elms = $('.paramSection');
        Object.keys(elms).forEach(function (i) {
            var elm = elms.eq(Number(i));
            if (elm.length > 0) {
                var id = elm.attr('id');
                self.tops[id] = Math.floor(elm.offset().top);
            }
        });
    };
    toNextSection.prototype.getNextSectionId = function () {
        var self = this;
        var nowTop = $(window).scrollTop();
        var currentSectionId = '';
        Object.keys(this.tops).some(function (id) {
            var top = self.tops[id];
            currentSectionId = id;
            if (nowTop < top) {
                return true;
            }
        });
        return currentSectionId;
    };
    toNextSection.prototype.scrollTo = function (id) {
        var position = $('#' + id).offset().top;
        $("html, body").animate({ scrollTop: position }, 300, 'linear');
    };
    return toNextSection;
}());
exports.toNextSection = toNextSection;
exports.default = toNextSection;
